<template>
  <div class="container container-fluid flex">
    <div v-if="showComponentData">
      <div class="row">
        <h4>Fotos de los presupuestos</h4>
        <p>EN CASO DE TENERLOS</p>
        <!-- FOTOS PRESUPUESTO -->
        <div v-if="isFieldVisible('existing_photo_estimate_files')" class="col-md-4">
          <div v-for="(customField, index) in customFields" :key="index">
            <div class="form-group bordered mb-3">
              <label :for="'existing_photo_estimate_files' + index" class="form-label text-left">
                {{ getFieldDescription('existing_photo_estimate_files') }} {{ index + 1 }}
              </label>
            </div>
            <div>
              <div>
                <div @click="openCamera(index)" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_estimate_files' + index"
                  :id="'photo_estimate_files' + index"
                  style="display: none;"
                  @change="onFileChange(index)"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="customField.photoFile" @click="openImageModal(customField.photoFile)">
              Ver Imagen
            </div>
          </div>
          <div @click="addCustomField" class="btn btn-secondary mt-2" title="Agregar componente">Agregar</div>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
    <!-- MODAL -->
    <ShowImagesModal :modalId="'imageModalPhotoEstimateFiles'" :currentImage="currentImage" :currentImageName="currentImageName" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js';
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';

export default {
  name: 'FormPhotoEstimate',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');
    const customFields = ref([]);
    const formData = ref([]);

    const openCamera = (index) => {
      const inputElement = document.getElementById('photo_estimate_files' + index);
      inputElement.click();
    };

    const cargarDatos = () => {
      try {
        showComponentData.value = dataCompany.value && dataCompany.value.existing_photo_estimate_files;
        customFields.value.push({ photoFile: null });
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);

      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;

        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoEstimateFiles').modal('show');
    };

    const onFileChange = async (index) => {
      const fileInput = document.getElementById('photo_estimate_files' + index);
      const files = fileInput.files;

      try {
        const rotatedFile = await rotateImageIfNeeded(files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        customFields.value[index].photoFile = compressedFile;

        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const newFormData = {};
      customFields.value.forEach((field, index) => {
        newFormData['photo_estimate_files' + index] = field.photoFile;
      });

      formData.value = newFormData;
      emit('formDataChanged', formData.value);
    };

    const addCustomField = () => {
      customFields.value.push({ photoFile: null });
      emitFieldChanged();
    };

    onMounted(() => {
      cargarDatos();
    });

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      addCustomField,
      customFields,
      formData,
      openCamera
    };
  },
};
</script>
